import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { getColor, rgbaColor } from 'helpers/utils';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LineChart,
  LegendComponent
]);

const tooltipFormatter = params => {
  return params
    .map(
      ({ value, seriesName, borderColor }) =>
        `<div class="dot me-1 fs--2 d-inline-block" style="background-color: ${borderColor}"></div>
              <span class='text-600'>${seriesName}: ${value}</span>`
    )
    .join('<br/>');
};

const calculateTrendLine = (data) => {
  const n = data.length;

  // Calculate sum of x and y values
  let sumX = 0;
  let sumY = 0;
  for (let i = 0; i < n; i++) {
    sumX += i + 1; // x values (assuming data is evenly spaced)
    sumY += data[i]; // y values (your data)
  }

  // Calculate mean of x and y values
  const meanX = sumX / n;
  const meanY = sumY / n;

  // Calculate slope (m) and intercept (c)
  let numerator = 0;
  let denominator = 0;
  for (let i = 0; i < n; i++) {
    numerator += (i + 1 - meanX) * (data[i] - meanY);
    denominator += Math.pow(i + 1 - meanX, 2);
  }
  const slope = numerator / denominator;
  const intercept = meanY - slope * meanX;

  // Generate trend line data based on the calculated slope and intercept
  const trendLine = [];
  for (let i = 0; i < n; i++) {
    const trendValue = slope * (i + 1) + intercept;
    trendLine.push(trendValue);
  }

  return trendLine;

};

const getOptions = (lineData, barData, xdata) => ({
  color: getColor('gray-100'),
  tooltip: {
    trigger: 'axis',
    padding: [7, 10],
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-100'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    formatter: tooltipFormatter,
    transitionDuration: 0
  },
  legend: {
    data: ['Total support tickets','Trend line'],
    show: false
  },
  xAxis: {
    type: 'category',
    position: 'bottom',
    data:xdata,
    boundaryGap: false,
    axisPointer: {
      lineStyle: {
        color: getColor('gray-200'),
        type: 'line'
      }
    },
    splitLine: { show: false },
    axisLine: {
      lineStyle: {
        color: getColor('gray-200'),
        type: 'line'
      }
    },
    axisTick: { show: false },
    axisLabel: {
      color: getColor('gray-500'),
      formatter(value) {
        return value;
      },
      interval: 0, // Show all labels
      margin: 15,
      showMinLabel: true,
      showMaxLabel: true,
      align: 'center'
    }
  },
  yAxis: {
    type: 'value',
    splitNumber: 3,
    axisPointer: { show: false },
    splitLine: {
      lineStyle: {
        color: getColor('gray-200'),
        type: 'line'
      }
    },
    boundaryGap: false,
    axisLabel: {
      showMinLabel: false,
      show: true,
      color: getColor('gray-400'),
      formatter: value => value
    },
    axisTick: { show: false },
    axisLine: { show: false }
  },
  series: [
    {
      type: 'line',
      name: 'Line',
      data: lineData,
      showSymbol: false,
      symbol: 'circle',
      itemStyle: {
        borderColor: '#5C6BC0',
        borderWidth: 2
      },
      lineStyle: {
        color: '#5C6BC0'
      },
      symbolSize: 2
    },
    {
      type: 'bar',
      name: 'Bar',
      data: barData,
      barWidth: '50%', // Adjust bar width as needed
      itemStyle: {
        color: '#2196F3'
      }
    }
    
  ],
  grid: {
    right: '10px',
    left: '30px',
    bottom: '15%',
    top: '5%'
  }
});
const AverageEnrollmentChart = forwardRef(({ data}, ref) => {



 
   const barData =data.totalSupportCalls //[
   //  20, 25, 30, 22, 28, 20, 25, 30, 22, 28, 20, 25, 30, 22, 28, 20, 25, 30, 22, 28, 20, 25, 30, 22, 28, 20, 25, 30, 22, 28   // Example bar data corresponding to 'xdata'
  // ];
  
  const lineData =calculateTrendLine(barData) //[
    // 30,29,28,27,26,25,24,23,22,21,20,19,18,17,16,15,14,13,12,11,10,9,8,7,6,5,4,3,2,1
   /// ];

   const xdata =data.xAxisData //["08", "09", "10", "11", "12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30"]; // Define x-axis data

   
  return (
    <>
    {/* {JSON.stringify(data)} */}

    <ReactEChartsCore ref={ref} echarts={echarts} option={getOptions(lineData, barData, xdata)} />
    </>
  );
});

AverageEnrollmentChart.propTypes = {
  data: PropTypes.shape({
    onSaleCourse: PropTypes.array,
    regularPaidCourse: PropTypes.array
  })
};

export default AverageEnrollmentChart;
